import { ChangeDetectorRef, Component, OnInit } from '@angular/core';

import { ENTER } from '@angular/cdk/keycodes';
import { CellDoubleClickedEvent, ColDef, GetRowIdParams, GridApi, GridOptions, IServerSideDatasource, IServerSideGetRowsParams } from 'ag-grid-community';
import { LicenseManager } from "ag-grid-enterprise";

import { AgGridModule } from 'ag-grid-angular';
import { MatButtonModule } from '@angular/material/button';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatChipsModule } from '@angular/material/chips';
import { MatChipInputEvent } from '@angular/material/chips';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatDialog } from '@angular/material/dialog';
import { MatSelectModule } from '@angular/material/select';
import { MatSnackBar, MatSnackBarModule } from '@angular/material/snack-bar';
import { Router } from '@angular/router';

import { NewArtPieceComponent } from '../newArtPiece/newArtPiece.component';
import { itemService } from '../../../helpers/services/main.service';
import { artPieceService } from '../../../helpers/services/art_piece.service';
import { CustomTooltipComponent } from '../../../components/custom-tooltip/custom-tooltip.component';
import { imageComponent } from '../../itemLibrary/image/image.component';
import { NewItemDialogComponent } from '../../itemLibrary/newItem-dialog/newItem-dialog.component';

import { SearchTagComponent } from 'src/app/components/search-tag/search-tag.component';
import { ResetAgGridFiltersComponent } from 'src/app/components/reset-aggrid-filters/reset-aggrid-filters.component';
import { GridThemeEventsService } from 'src/@vex/services/grid.theme.service';
import { GridSidebarEventsService } from 'src/@vex/services/grid.sidebar.service';
import { GRID_SIDEBAR_CONFIG } from 'src/app/helpers/ag-grid/grid-sidebar.config';
import { ART_PIECE_COLUMN_HEADERS_CONFIG } from 'src/app/helpers/ag-grid/art.piece.config';
import { firstValueFrom, forkJoin, Observable, of, Subject, takeUntil } from 'rxjs';
import { catchError, shareReplay, tap } from 'rxjs/operators';
import { GridUISetupService } from 'src/@vex/services/grid-ui.service';
import { LoaderService } from '../../../helpers/services/loader.service';
import { GridActiveChipsComponent } from '../../../components/grid-active-chips/grid-active-chips.component';
import { ArtPieceDeleteConfirmDialogComponent } from '../art-piece-delete-confirm-dialog/art-piece-delete-confirm-dialog.component';
import { AgGridCellNotesHandle, AgGridCellNotesService } from '../../../helpers/ag-grid/cell-notes/ag-grid-cell-notes.service';
import { getCurrentUserDisplayName, mergePreloadCellNotes, suppressImageColumnNotes,
} from '../../../helpers/ag-grid/cell-notes/ag-grid-cell-notes.helpers';

@Component({
  selector: 'app-art-piece',
  imports: [
    AgGridModule,
    MatButtonModule,
    MatTooltipModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    MatChipsModule,
    MatToolbarModule,
    SearchTagComponent,
    MatSelectModule,
    MatSnackBarModule,
    ResetAgGridFiltersComponent,
    GridActiveChipsComponent
],
  templateUrl: './art-piece.component.html',
  styleUrls: ['./art-piece.component.scss'],
  standalone: true,
})
export class ArtPieceComponent implements OnInit {

  gridClass: any = 'ag-theme-alpine';
  private isInitialLoad = true;
  detailRowHeight = 200;
  paginationPageSize = 100;
  totalRowCount: number = 0;
  tooltipShowDelay = 1000;
  tooltipShowMode: "whenTruncated"
  groupRowRendererParams = { checkbox: false, rowDrag: true };
  serverSideDatasource: IServerSideDatasource;
  pagination = true;
  gridOptions: GridOptions;
  columnTypes;
  groupRows = 'groupRows';
  columnDefs: ColDef[] = [];
  rowData: any[] = [];
  defaultColDef!: ColDef;
  params: any;
  gridApi: any;
  colHeaders: any = [];
  getRowNodeId: any;
  selectedCompanyCode: any;
  companyCode: any;
  divisionCode: any;
  selectedDivisionCode: any;
  role: string = '';
  selectedDivisionCodeStatus: any[] = [];
  divisionCodeStatus: any[] = [];
  RFQGroupList: any[] = [];
  merchGroups: any;
  frameworkComponents: any;
  artistOptions: any;
  seasonOptions: any;
  artTypeOptions: any[];
  ageGroupOptions: any[];
  // Tags search
    tagsQuery: string = '';
  searchTags: string[] = [];
  readonly separatorKeysCodes: number[] = [ENTER];
  toolbarVisible = true;
  private destroy$ = new Subject<void>();
  private artPieceViewsInit$: Observable<{ views: any[]; def: { view_name: string } | null }>;
  private initialArtPieceViewApplied = false;
  private artPieceCellNotes: AgGridCellNotesHandle;

  // View selector properties
  selectedViewLayout: any;
  viewLayouts: any[] = [{ layout_name: 'Default' }];
  newViewInput = false;
  hasActiveChips = false;
  currentUrl: string = '';
  isArchive: boolean = false;
  canDeleteArtPiece = false;
  userRole = '';
  selectedArtPieceCount = 0;
  /** Snackbar duration when delete is blocked (linked items, etc.) */
  private readonly deleteBlockedSnackDurationMs = 20000;

  constructor(
    private dialog: MatDialog,
    private router: Router,
    public itemService: itemService,
    public artPieceService: artPieceService,
    private gridUISetupService: GridUISetupService,
    private loaderService: LoaderService,
    private _snackBar: MatSnackBar,
    private cdr: ChangeDetectorRef,
    private agGridCellNotesService: AgGridCellNotesService,
  ) {
    const url = this.router.url;
    const urlParts = url.split('/');
    this.currentUrl = urlParts[urlParts.length - 1];
    this.isArchive = this.currentUrl === 'archive';
    this.frameworkComponents = { 'imageEditor': imageComponent, customTooltip: CustomTooltipComponent };
    this.getRowNodeId = (params: GetRowIdParams) =>
      params.data?.id != null ? String(params.data.id) : '';
   // this.getContextMenuItems = this.getContextMenuItems.bind(this);

    this.defaultColDef = {
      resizable: true,
      sortable: true,
      filter: 'agTextColumnFilter',
      floatingFilter: true,
      editable: true,
      pivot: false,
      wrapHeaderText: true,
      autoHeaderHeight: true,
      onCellDoubleClicked: this.navigateToArtPieceDetail
    };

    this.artPieceCellNotes = this.agGridCellNotesService.createDataSource(
      'art_piece',
      getCurrentUserDisplayName,
    );

    this.gridOptions = {
      rowModelType: 'serverSide',          // Use SSRM (Server-Side Row Model)
      popupParent: document.body,
      defaultColDef: this.defaultColDef, // This is now defined
      cacheBlockSize: 100,                 // Rows per block
      maxBlocksInCache: 10,                // Max blocks kept in memory
      blockLoadDebounceMillis: 500,        // Debounce scroll loading
      animateRows: true,
      loading: true,
      suppressLoadingOverlay: true,
      enableFilterHandlers: true,
      sideBar: GRID_SIDEBAR_CONFIG,
      components: this.frameworkComponents,
      tooltipShowMode: 'whenTruncated',
      tooltipShowDelay: 1000,
   //   rowSelection: { mode: 'multiRow', enableClickSelection: false, groupSelects : "descendants" },
      getRowId: (params: GetRowIdParams) =>
        params.data?.id != null ? String(params.data.id) : '',
      notesDataSource: this.artPieceCellNotes.dataSource,
      onSelectionChanged: () => this.onArtPieceSelectionChanged(),
      context: {
       router: this.router,
       artPieceService: this.artPieceService,
       snackBar: this._snackBar,
       currentUrl: this.currentUrl,
       loaderService: this.loaderService
      },
      statusBar: {
        statusPanels: [
          { statusPanel: 'agTotalRowCountComponent', align: 'center' },
          { statusPanel: 'agFilteredRowCountComponent' },
          { statusPanel: 'agSelectedRowCountComponent' },
          { statusPanel: 'agAggregationComponent' }
        ]
      },
    };

    this.artPieceViewsInit$ = forkJoin({
      views: this.itemService.getUserGridViews({ grid_id: 'artPiece' }).pipe(catchError(() => of([]))),
      def: this.itemService.getGridDefaultView({ grid_id: 'artPiece' }).pipe(catchError(() => of(null)))
    }).pipe(
      tap(({ views, def }) => this.applyArtPieceViewListFromApi(views, def)),
      shareReplay(1)
    );
    this.artPieceViewsInit$.subscribe({ error: (err) => console.error('[ArtPieceComponent] artPieceViewsInit$ failed:', err) });
  }

  private applyArtPieceViewListFromApi(views: any[], def: { view_name: string } | null): void {
    if (views && views.length) {
      this.viewLayouts = views.map((v: any) => ({
        layout_name: v.view_name,
        is_default: !!v.is_default
      }));
    } else {
      this.viewLayouts = [{ layout_name: 'Default' }];
    }
    const defaultName = def?.view_name;
    const match = defaultName && this.viewLayouts.find((v) => v.layout_name === defaultName);
    this.selectedViewLayout = match || this.viewLayouts[0];
  }

  private tryApplyInitialArtPieceView(): void {
    if (this.initialArtPieceViewApplied || !this.gridApi || !this.columnDefs?.length) {
      return;
    }
    this.initialArtPieceViewApplied = true;
    firstValueFrom(this.artPieceViewsInit$)
      .then(() => {
        this.applyGridViewStateForViewName(this.selectedViewLayout?.layout_name ?? 'Default');
      })
      .catch(() => {
        this.applyGridViewStateForViewName(this.selectedViewLayout?.layout_name ?? 'Default');
      });
  }

  async ngOnInit(): Promise<void> {
    try {
      // Start loader immediately to prevent blank page flash
      this.loaderService.increment();
      
      (window as any).togglePageToolbar = this.toggleToolbarVisibility.bind(this);

      try {
        const roleRes: any = await firstValueFrom(this.itemService.verifyRole());
        if (roleRes && roleRes !== 'unauthorized') {
          this.userRole = roleRes.role || '';
        }
      } catch {
        this.userRole = '';
      }
      const r = (this.userRole || '').toLowerCase();
      this.canDeleteArtPiece = ['designer', 'sales', 'production', 'admin'].includes(r);

      const colHeadersData: any = ART_PIECE_COLUMN_HEADERS_CONFIG.columnDefs;

      await this.loadCompanyData();

      if (!this.selectedDivisionCode || !this.selectedDivisionCodeStatus) {
        return;
      }

      const groupsData: any = await firstValueFrom(this.itemService.getMerchGroup({ divisionCode: [1, 8, 9] }));

      this.prepareGridHeaders(colHeadersData, groupsData);
      this.setupServerSideDatasource();
      this.syncArtPieceDeleteSelectionUi();

    } catch (error) {
      console.error('Art Piece init failed', error);
    }
  }

  private async loadCompanyData(): Promise<void> {
    const companyData = await firstValueFrom( this.itemService.getCompanyCode());
    this.selectedCompanyCode = companyData[0]['company_name'];
    this.companyCode = companyData;
    this.divisionCode = companyData[0].divisionCodes;
    this.selectedDivisionCode = companyData[0].divisionCodes;
    window['selectedDivisionCode'] = companyData[0].divisionCodes;
  }

  private prepareGridHeaders( colHeadersData: any[], groupsData: any[]): void {
    for (let i = colHeadersData.length - 1; i >= 0; i--) {
      if (colHeadersData[i].colId === '__artPieceSelect__') {
        colHeadersData.splice(i, 1);
      }
    }
    this.mapHeaders(colHeadersData, groupsData);
    this.decorateColumns(colHeadersData);

    this.colHeaders = colHeadersData;
    this.columnDefs = colHeadersData;
    this.merchGroups = groupsData;
    this.gridApi?.setGridOption('columnDefs', this.columnDefs);
    this.tryApplyInitialArtPieceView();
  }

  /**
   * AG Grid v32+ uses rowSelection + selectionColumnDef; legacy checkboxSelection on ColDef is ignored.
   * Call after gridReady and after role/column setup so checkboxes work (avoids race with verifyRole).
   */
  private syncArtPieceDeleteSelectionUi(): void {
    if (!this.gridApi) {
      return;
    }
    if (this.canDeleteArtPiece) {
      this.gridApi.setGridOption('rowSelection', {
        mode: 'multiRow',
        checkboxes: true,
        headerCheckbox: true,
        enableClickSelection: false,
        selectAll: 'currentPage',
      });
      this.gridApi.setGridOption('selectionColumnDef', {
        sortable: false,
        resizable: false,
        width: 52,
        pinned: 'left',
        lockPosition: true,
        suppressMovable: true,
        suppressHeaderMenuButton: true,
        cellClass: 'art-piece-selection-cell',
        headerClass: 'art-piece-selection-header',
      });
    } else {
      this.gridApi.setGridOption('rowSelection', undefined as any);
      this.gridApi.setGridOption('selectionColumnDef', undefined as any);
    }
    this.onArtPieceSelectionChanged();
  }

  private decorateColumns(headers: any[]): void {
    headers.forEach(col => {
      if (col.colId === 'pic') {
        col.cellRenderer = 'imageEditor';
        col.cellStyle = (params: any) =>
          params.value ? { 'text-align': '-webkit-center' } : null;
      } else {
        col.tooltipField = col.field;
        col.tooltipComponent = 'customTooltip';
      }
    });
  }

  private setupServerSideDatasource(): void {
    if (!this.gridApi) return;
  
    this.serverSideDatasource = this.createServerSideDatasource();
    this.gridApi.setGridOption('serverSideDatasource',  this.serverSideDatasource);
    this.gridApi?.setGridOption('loading', false)
  }

  toggleToolbarVisibility() {
    this.toolbarVisible = !this.toolbarVisible;
  }

  getMasterFiledName(colId) {
    for (var i = 0; this.colHeaders.length > i; i++) {
      if (this.colHeaders[i].col_id == colId) {
        return this.colHeaders[i].field
      }
    }
  }

  sanitizeDbColumn(col: any): any {
    const def: any = {
      ...col,
      colId: col.col_id ?? col.field,
      field: col.field,
      headerName: col.headerName ?? this.getMasterFiledName(col.col_id),
      width: col.width ? Number(col.width) : 150,

      filter: col.filter_type === 'agSetColumnFilter'
      ? 'agTextColumnFilter'
      : col.filter_type ?? "agTextColumnFilter",
      hide: col.hide === "true" || col.hide === true,
      sortable: true,
      resizable: true
    };

    if (col.field === "pic") {
      def.cellRenderer = "imageEditor";
      def.filter = false;
      def.floatingFilter = false;
      suppressImageColumnNotes(def);
    }

    if (col.field === 'item_name') {
      def.width = 450;      // override default
    }

    return def;
  }

  createServerSideDatasource(): IServerSideDatasource {
    return {
      getRows: (params: IServerSideGetRowsParams) => {
        const request = {
          startRow: params.request.startRow,
          endRow: params.request.endRow,
          filterModel: {
            ...(params.request.filterModel || {}),
            ...(this.tagsQuery ? { tags: { type: 'contains', filter: this.tagsQuery } } : {})
          },
          isArchive: this.isArchive
        };

        this.artPieceService.getAllitems(request).subscribe({
          next: async (res: any) => {
            const rowData = res.rows || [];
            const totalCount = res.totalCount ?? rowData.length;

            this.rowData = rowData;
            this.totalRowCount = totalCount;

            const statusPanelComp = this.gridApi.getStatusPanel('customTotalCount');
            if (statusPanelComp) {
              statusPanelComp.setTotalCount(totalCount);
            }

            // Always set loading to false when we have a response
            this.gridApi.setGridOption("loading", false);

            // Decrement loader for initial load (accounting for manual increment in ngOnInit)
            if (this.isInitialLoad) {
              this.isInitialLoad = false;
              this.loaderService.decrement();
            }

            params.success({
              rowData,
              rowCount: totalCount,
            });

            mergePreloadCellNotes(this.artPieceCellNotes, rowData, 'id');
            this.restoreStateFromSession();
          },
          error: (error) => {
            this.gridApi.setGridOption("loading", false);
            // Decrement loader on error for initial load
            if (this.isInitialLoad) {
              this.isInitialLoad = false;
              this.loaderService.decrement();
            }
            params.fail();
          }
        });
      }
    };
  }

  onFirstDataRendered(params: any) {
    setTimeout(() => {
      if (params && params.api) {
        params.api.resetRowHeights();
      }

      const allColumnIds: string[] = [];
      if (params && params.columnApi) {
        const columns = params.columnApi.getColumns();
        if (columns) {
            columns.forEach((column: any) => {
                allColumnIds.push(column.getColId());
            });
        }
        params.columnApi.autoSizeColumns(allColumnIds, false);
      }
    }, 100);
  }
  
  onGridReady(params) {
    this.params = params;
    this.gridApi = params.api;
    window['gridApi'] = this.gridApi;
    this.gridUISetupService.bootstrap(this.gridApi, this.destroy$);

    if (this.columnDefs?.length) {
      this.gridApi.setGridOption('columnDefs', this.columnDefs);
    }

    this.syncArtPieceDeleteSelectionUi();

    this.gridApi.setGridOption("loading", true);
  
    if (this.columnDefs && this.columnDefs.length > 0) {
      this.setupServerSideDatasource();
    }
    this.tryApplyInitialArtPieceView();
  }

  onFilterChanged(e) {
    this.saveStateToSession();
  }

  onColumnStateChanged(e) {
    this.saveStateToSession();
  }

  private saveStateToSession(): void {
    if (!this.gridApi) return;
    const state = {
      columnState: this.gridApi.getColumnState(),
      filterModel: this.gridApi.getFilterModel(),
      timestamp: Date.now()
    };
    sessionStorage.setItem('gridState_artPiece', JSON.stringify(state));
  }

  private restoreStateFromSession(): void {
    if (!this.gridApi) return;
    const saved = sessionStorage.getItem('gridState_artPiece');
    if (saved) {
      try {
        const state = JSON.parse(saved);
        if (state.columnState) {
          this.gridApi.applyColumnState({ state: state.columnState, applyOrder: true });
        }
        if (state.filterModel && Object.keys(state.filterModel).length > 0) {
          this.gridApi.setFilterModel(state.filterModel);
        }
      } catch (e) {
        console.warn('Failed to restore grid state from session:', e);
      }
    }
  }

  compareViewLayouts = (a: { layout_name: string } | null, b: { layout_name: string } | null): boolean =>
    a?.layout_name != null && b?.layout_name != null && a.layout_name === b.layout_name;

  onViewChange(value) {
    this.selectedViewLayout = value;
    this.applyGridViewStateForViewName(value.layout_name);
  }

  private applyGridViewStateForViewName(layoutName: string): void {
    if (!this.gridApi || !layoutName) {
      return;
    }
    this.itemService.getGridViewState({ grid_id: 'artPiece', view_name: layoutName }).subscribe((res: any) => {
      if (res) {
        if (res.column_state && res.column_state.length > 0) {
          this.gridApi.applyColumnState({ state: res.column_state, applyOrder: true });
        }
        if (res.filter_model) {
          setTimeout(() => {
            this.gridApi?.setFilterModel(res.filter_model);
          }, 200);
        }
      } else {
        this.itemService
          .getSelectedGridView({ layout_name: layoutName, grid_id: 'artPiece' })
          .subscribe((legacyRes: any) => {
            if (legacyRes?.length > 0) {
              this.gridApi.applyColumnState({ state: legacyRes, applyOrder: true });
            }
          });
      }
    });
  }

  hasArtPieceDefaultView(): boolean {
    return this.viewLayouts.some((v) => v.is_default);
  }

  onSetArtPieceViewAsDefault(): void {
    const v = this.selectedViewLayout;
    if (!v?.layout_name || v.layout_name === 'Default') {
      return;
    }
    this.itemService.setGridDefaultView({ grid_id: 'artPiece', view_name: v.layout_name }).subscribe({
      next: () => {
        this.viewLayouts = this.viewLayouts.map((x) => ({
          ...x,
          is_default: x.layout_name === v.layout_name
        }));
        this.selectedViewLayout =
          this.viewLayouts.find((x) => x.layout_name === v.layout_name) ?? this.selectedViewLayout;
        this._snackBar.open('This view will load by default when you open Art Piece.', 'close');
      },
      error: (err) => {
        this._snackBar.open(err?.error?.message || 'Could not set default view.', 'close');
      }
    });
  }

  onClearArtPieceDefaultView(): void {
    this.itemService.setGridDefaultView({ grid_id: 'artPiece', clear: true }).subscribe({
      next: () => {
        this.viewLayouts = this.viewLayouts.map((x) => ({ ...x, is_default: false }));
        this._snackBar.open('Custom default cleared. Global Default will load on next visit.', 'close');
      },
      error: (err) => {
        this._snackBar.open(err?.error?.message || 'Could not clear default view.', 'close');
      }
    });
  }

  onSaveLayout(selectedView) {
    if (selectedView.layout_name !== 'Default' && selectedView.layout_name != null) {
      const columnState = this.gridApi.getColumnState();
      const filterModel = this.gridApi.getFilterModel();
      this.itemService.saveGridViewState({
        grid_id: 'artPiece',
        view_name: selectedView.layout_name,
        column_state: columnState,
        filter_model: filterModel
      }).subscribe(
        (data) => {
          this._snackBar.open(`Current view was saved successfully.`, 'close');
        },
        (error) => {
          this._snackBar.open(`Failed to save view. Please try again.`, 'close');
          console.error('Error saving grid view state:', error);
        }
      );
    } else {
      this._snackBar.open(`You can't save on Default view. Please select a different view or create a new one.`, 'close');
    }
  }

  onSaveNewView(viewName: string) {
    if (viewName && viewName.trim()) {
      const name = viewName.trim();
      this.viewLayouts.push({ layout_name: name, is_default: false });
      this.selectedViewLayout = { layout_name: name, is_default: false };
      this.onSaveLayout(this.selectedViewLayout);
    }
  }

  onFilterModified(e) {
    e.filterInstance.getModel()
    e.filterInstance.getModelFromUi()

  }


  onCellMouseOver(params) {
    params.node.targetElementSrc = params.event.target
    params.node.tooltipDisplayValue = params.value
  }

  navigateToArtPieceDetail(params: CellDoubleClickedEvent) {
    const id = params?.data?.id;
    if (!id) return;
    params.context.router.navigate([`/apps/art-piece/${id}`]);
  }

  mapHeaders(colHeadersData: any, fetchedGroups: any) {
    this.mapHeaderValues(colHeadersData, fetchedGroups, 'Licensor')
    this.mapHeaderValues(colHeadersData, fetchedGroups, 'Property')
    this.mapHeaderValues(colHeadersData, fetchedGroups, 'Little Theme')
    this.mapHeaderValues(colHeadersData, fetchedGroups, 'Big Theme')
    this.mapHeaderValues(colHeadersData, fetchedGroups, 'Art Source')
    this.mapHeaderValues(colHeadersData, fetchedGroups, 'Style Guide')
    // Artist (and Customer) are merch-group types — same resolution as Licensor / Property
    this.mapHeaderValues(colHeadersData, fetchedGroups, 'Artist')
    this.mapHeaderValues(colHeadersData, fetchedGroups, 'Customer')
    this.mapHeaderValues(colHeadersData, fetchedGroups, 'Age Group')
    this.mapHeaderValues(colHeadersData, fetchedGroups, 'Art Type')
  }

  /** Normalize merch header labels so "Style guide" / "Style Guide" / "Art Type" all match. */
  private normalizeMerchTypeLabel(label: string): string {
    return (label || '').toLowerCase().replace(/\s/g, '');
  }

  mapHeaderValues(colHeadersData: any, fetchedGroups: any, header: any) {
    const headerLower = String(header).toLowerCase().trim();
    const column = colHeadersData.find(
      (h: any) => h?.headerName && h.headerName.toLowerCase().trim() === headerLower
    );
    if (!column) return;

    const rowFieldKey =
      column.field != null && String(column.field).trim() !== ''
        ? column.field
        : headerLower.replace(/\s+/g, '_');

    const headerKey = this.normalizeMerchTypeLabel(headerLower);

    column.valueGetter = (m) => {
      const group = fetchedGroups.find((g: any) => g?.divCode_id === m?.data?.divisioncode_id);
      const groupList = group?.merchGroupHeaders?.find(
        (g: any) => this.normalizeMerchTypeLabel(g?.mgTypeDesc) === headerKey
      )?.merchGroups;

      if (!groupList) return null;

      return groupList.find((mg: any) => mg?.mg_id === m?.data?.[rowFieldKey])?.mg_desc;
    };
  }


  onCreateNewItem = async () => {
    const dialogRef = this.dialog.open(NewArtPieceComponent, {
      width: '100vw',
      maxWidth: '900px',
      maxHeight: '90vh',
      panelClass: 'art-piece-full-dialog',
      autoFocus: false,
      restoreFocus: false,
    });
  
    dialogRef.afterClosed().subscribe(async (result) => {
      try {
        if (result && result.data) {
          if (this.gridApi) {
            this.gridApi.showLoadingOverlay();
            this.serverSideDatasource = this.createServerSideDatasource();
            this.gridApi.setGridOption("serverSideDatasource", this.serverSideDatasource);
          }
        }
      } catch (error) {
        console.error('Error creating new art piece', error);
      }
    });
  }

  convertToItem(artPiece: any) {
    if (!artPiece) {
      return;
    }

    const division = this.companyCode[0]?.divisionCodes.find(c => c.divCode_id === artPiece.divisioncode_id);
    
    const dialogRef = this.dialog.open(NewItemDialogComponent, {
      panelClass: 'create-new-item-dialog',
      width: 'min(1180px, calc(100vw - 48px))',
      maxWidth: 'calc(100vw - 48px)',
      maxHeight: 'calc(100vh - 48px)',
      data: {
        type: 'new',
        attachments: [],
        prefilledData: {
          divisionCode: division,
          season: artPiece.season,
          bigTheme: artPiece.big_theme,
          littleTheme: artPiece.little_theme,
          licensor: artPiece.licensor,
          property: artPiece.property,
          artType: artPiece.art_type,
          artSource: artPiece.art_source,
          artist: artPiece.artist,
          ageGroup: artPiece.age_group,
          itemDescription: artPiece.description,
          imageLink: artPiece.pic,
          thumbImageLink: artPiece.pic,
          dsn_ref_num: this.rowData.find(data => data.id === artPiece.id)?.art_number || '',
          tags: this.rowData.find(data => data.id === artPiece.id)?.tags || '',
          art_piece_id: artPiece.id
        }
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
      }
    });
  }

  onArtPieceSelectionChanged(): void {
    if (!this.gridApi || !this.canDeleteArtPiece) {
      this.selectedArtPieceCount = 0;
    } else {
      this.selectedArtPieceCount = this.gridApi.getSelectedRows()?.length ?? 0;
    }
    setTimeout(() => this.cdr.detectChanges(), 0);
  }

  onToolbarDeleteSelected(ev?: Event): void {
    ev?.preventDefault();
    ev?.stopPropagation();
    if (!this.gridApi || !this.canDeleteArtPiece) {
      return;
    }
    const rows = this.gridApi.getSelectedRows();
    if (!rows?.length) {
      this._snackBar.open('Select one or more art pieces to delete.', 'close', { duration: 3000 });
      return;
    }
    this.openDeleteConfirmDialog(rows, this.gridApi);
  }

  private openDeleteConfirmDialog(rows: any[], api?: GridApi): void {
    const artPieces = rows
      .map((r) => ({
        id: r.id,
        description: r.description,
        art_number: r.art_number,
      }))
      .filter((p) => p.id != null);

    if (!artPieces.length) {
      this._snackBar.open('No valid art pieces selected.', 'close');
      return;
    }

    const ids = artPieces.map((p) => p.id) as number[];

    this.loaderService.increment();
    this.artPieceService.checkDeleteEligibility(ids).subscribe({
      next: (checkRes: any) => {
        this.loaderService.decrement();
        if (checkRes?.canDelete !== true) {
          this._snackBar.open(this.getDeleteBlockedSnackMessage(ids, checkRes), 'close', {
            duration: this.deleteBlockedSnackDurationMs,
          });
          return;
        }

        const count = artPieces.length;
        const single = artPieces[0];
        const label =
          count === 1
            ? (single.art_number || single.description || `ID ${single.id}`)
            : `${count} art pieces`;

        const dialogRef = this.dialog.open(ArtPieceDeleteConfirmDialogComponent, {
          width: '440px',
          autoFocus: false,
          data: {
            title: count === 1 ? 'Delete art piece' : 'Delete art pieces',
            message:
              count === 1
                ? `Are you sure you want to permanently delete "${label}"? This cannot be undone.`
                : `Are you sure you want to permanently delete ${count} selected art pieces? This cannot be undone.`,
          },
        });

        dialogRef.afterClosed().subscribe((confirmed) => {
          if (!confirmed) {
            return;
          }
          this.performDelete(ids, api);
        });
      },
      error: (err) => {
        this.loaderService.decrement();
        const msg =
          err?.error?.message ||
          'Could not verify whether this art piece can be deleted.';
        this._snackBar.open(msg, 'close', { duration: this.deleteBlockedSnackDurationMs });
      },
    });
  }

  private getDeleteBlockedSnackMessage(ids: number[], res: any): string {
    const linkedNums = Array.isArray(res?.linkedItemNums)
      ? res.linkedItemNums.filter((n: string) => n != null && String(n).trim() !== '')
      : [];

    const linkedMessageSingle =
      'Cannot delete: an item was created using this art piece.';
    const bulkLinkedMessage =
      'Cannot delete: one or more selected art pieces have items created from them.';

    if (res?.code === 'LINKED_ITEMS') {
      const base = ids.length > 1 ? bulkLinkedMessage : linkedMessageSingle;
      if (linkedNums.length > 0) {
        return `${base} Item num(s): ${linkedNums.join(', ')}.`;
      }
      return `${base} Check the item library for the linked item record.`;
    }
    return res?.message || 'Unable to delete art piece(s).';
  }

  private performDelete(ids: number[], api?: GridApi): void {
    if (!ids.length) {
      return;
    }
    this.loaderService.increment();
    this.artPieceService.deleteArtPieces(ids).subscribe({
      next: (res: any) => {
        this.loaderService.decrement();
        const gridApi = api ?? this.gridApi;
        if (res?.status === true) {
          this._snackBar.open(
            ids.length === 1
              ? 'Art piece deleted successfully.'
              : `${ids.length} art pieces deleted successfully.`,
            'close',
            { duration: 3000 }
          );
          gridApi?.deselectAll();
          gridApi?.refreshServerSide({ purge: false });
          this.selectedArtPieceCount = 0;
        } else {
          this._snackBar.open(this.getDeleteBlockedSnackMessage(ids, res), 'close', {
            duration: this.deleteBlockedSnackDurationMs,
          });
        }
      },
      error: (err) => {
        this.loaderService.decrement();
        const msg =
          err?.error?.message || 'An error occurred while deleting art piece(s).';
        this._snackBar.open(msg, 'close', { duration: 6000 });
      },
    });
  }

  getContextMenuItems = (params: any) => {
    const { artPieceService, snackBar, currentUrl, loaderService } = params.context;

    if (!params.column) return ['note', 'copy', 'separator', 'export'];

    const tail = ['copy', 'separator', 'export'];

    const deleteMenuItem = this.canDeleteArtPiece
      ? {
          name: 'Delete',
          action: () => {
            const row = params.node?.data;
            if (!row?.id) {
              snackBar.open('Please select a row', 'close');
              return;
            }
            this.openDeleteConfirmDialog([row], params.api);
          },
        }
      : null;

    if (currentUrl !== 'archive') {
      const items: any[] = [
        {
          name: 'Archive',
          action: () => {
            if (params.node) {
              loaderService.increment();
              artPieceService.updateArchive(params.node.data).subscribe({
                next: (res: any) => {
                  if (res.status === true) {
                    params.api.refreshServerSide({ purge: false });
                    snackBar.open('Art piece archived successfully', 'close', { duration: 2000 });
                  } else {
                    snackBar.open('An error occurred while archiving', 'close');
                  }
                  loaderService.decrement();
                },
                error: () => {
                  snackBar.open('An error occurred while archiving', 'close');
                  loaderService.decrement();
                }
              });
            } else {
              snackBar.open('Please select a row', 'close');
            }
          }
        },
        {
          name: 'Convert to Item',
          action: () => {
            if (params.node) {
              this.convertToItem(params.node.data);
            }
          }
        },
      ];
      if (deleteMenuItem) {
        items.push(deleteMenuItem);
      }
      return ['note', ...items, ...tail];
    }

    const archiveItems: any[] = [
      {
        name: 'Unarchive',
        action: () => {
          if (params.node) {
            loaderService.increment();
            artPieceService.updateArchive(params.node.data).subscribe({
              next: (res: any) => {
                if (res.status === true) {
                  params.api.refreshServerSide({ purge: false });
                  snackBar.open('Art piece unarchived successfully', 'close', { duration: 2000 });
                } else {
                  snackBar.open('An error occurred while unarchiving', 'close');
                }
                loaderService.decrement();
              },
              error: () => {
                snackBar.open('An error occurred while unarchiving', 'close');
                loaderService.decrement();
              }
            });
          } else {
            snackBar.open('Please select a row', 'close');
          }
        }
      },
    ];
    if (deleteMenuItem) {
      archiveItems.push(deleteMenuItem);
    }
    return ['note', ...archiveItems, ...tail];
  }


  applyTagsFilter(tags: string[]) {
    if (!this.gridApi) return;
    this.tagsQuery = (tags || []).join(' ');
    this.serverSideDatasource = this.createServerSideDatasource();
    this.gridApi.setGridOption("serverSideDatasource", this.serverSideDatasource);
  }

  async onBtExport() {
    if (!this.gridApi) return;
    
    // Prepare base64 images if there are pictures in the data
    window['base64Images'] = [{}];
    if (this.rowData && this.rowData.length > 0) {
      for (let i = 0; i < this.rowData.length; i++) {
        if (this.rowData[i].pic) {
          try {
            window['base64Images'] = Object.assign({ 
              [this.rowData[i].pic]: await this.getBase64FromUrl(this.rowData[i].pic) 
            });
          } catch (error) {
            // Continue if image conversion fails
          }
        }
      }
    }
    
    this.gridApi.exportDataAsExcel();
  }

  async getBase64FromUrl(url: string): Promise<string> {
    if (!url) return '';
    
    try {
      const response = await fetch(url);
      const blob = await response.blob();
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(blob);
        reader.onloadend = () => {
          resolve(reader.result as string);
        };
        reader.onerror = reject;
      });
    } catch (error) {
      return '';
    }
  }

  resetFilters(): void {
    this.gridApi?.setFilterModel({});
    this.gridApi?.applyColumnState({defaultState: { sort: null }});
  }

  onChipsVisibilityChange(visible: boolean): void {
    this.hasActiveChips = visible;
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
